module.exports = __webpack_public_path__ + "img/active-substance.b6dd53fd.svg";